import { checkAiText } from './index'

export async function deleteTask (tlService, token, id) {
  try {
    await tlService.deleteTask(token, id)
  } catch (e) {
    console.log('error delete task', e)
    return false
  }
  return true
}

export async function checkTick (translate, tlService, taskIdRef, token, setPercent, deleteAfter, done, error, htmlWrap = true) {
  console.log('checkTick')
  if (taskIdRef.current > 0) {
    try {
      const resTaskStatus = await tlService.getTaskStatus(token, taskIdRef.current, 1)
      if (resTaskStatus?.data && resTaskStatus?.fullcount > 0) {
        const status = resTaskStatus.data[0]
        if (status?.status === 2 && status?.info?.steps > 0) {
          setPercent((status.info.step) / (status.info.steps + 2) * 100 + 1)
          // next tick
          setTimeout(() => checkTick(translate, tlService, taskIdRef, token, setPercent, deleteAfter, done, error, htmlWrap), 2000)
        } else if (status?.status === 3) {
          // done
          // parse result

          let res = ''
          let textResult = status?.result?.text
          if (textResult) {
            if (htmlWrap){
              textResult = textResult.replace(/.*<body>(.+)<\/body>.*/s, '$1')
              if (!textResult.match(/<p[^>]*>/)) {
                const arrText = textResult.split('\n\n')
                for (const t of arrText) {
                  res += `<p>${t.replaceAll(/\n/g, '<br />')}</p>`
                }
              } else {
                res = textResult
              }
            } else {
              res = textResult
            }
          }

          if (deleteAfter) {
            await deleteTask(tlService, token, taskIdRef.current)
          }
          setPercent(0)
          taskIdRef.current = 0
          done(res)
        } else if (status?.status === 4) {
          // error
          await deleteTask(tlService, token, taskIdRef.current)
          setPercent(0)
          taskIdRef.current = 0
          error({ text: translate('ai_task_error'), header: translate('ai_header_task_error') })
        }
      }
    } catch (e) {
      console.log('checkTick', e)
      await deleteTask(tlService, token, taskIdRef.current)
      setPercent(0)
      taskIdRef.current = 0
      error({ text: translate('ai_timeout_error'), header: translate('ai_header_timeout_error') })
    }
  }
}

export async function cancelClick (translate, tlService, taskIdRef, token, setPercent, setError) {
  try {
    await tlService.cancelTask(token, taskIdRef.current)
    await tlService.deleteTask(token, taskIdRef.current)
    taskIdRef.current = 0
  } catch (e) {
    console.log('handleCancelClick', e)
    setError({ text: translate('ai_cancel_error'), header: translate('ai_header_cancel_error') })
    return false
  }
  setPercent(0)
  return true
}

export async function runOurAi (tlService, text, token, promptValues, promptForOptimization,
  benchmarkList, useBenchmarkList, aiMaxTextSize, section, textLanguage, optimization = false) {

  if (useBenchmarkList === -1 || !benchmarkList[useBenchmarkList]) {
    return [0, { text: 'ai_no_enabled_task_types', header: 'ai_header_no_enabled_task_types' }]
  }

  if (!checkAiText(text, aiMaxTextSize, section)) {
    return [0, { text: 'ai_text_too_long', header: 'ai_header_text_too_long' }]
  }

  if (text?.length < 4) {
    return [0, { text: 'ai_text_too_short', header: 'ai_header_text_too_short' }]
  }

  // generate optimisation
  let optimizationValues = { ...promptValues }
  optimizationValues['optimizationPromptByUser'] = promptForOptimization?.length > 0 ? `${promptForOptimization.trim().replace(/\.$/, '')}. ` : ''

  optimizationValues = Object.fromEntries(
    Object.entries(optimizationValues).filter(([, value]) => value.toString()?.length)
  )

  try {
    const resTaskRun = await tlService.addTask(
      token,
      {
        run: 1,
        task_type_id: benchmarkList[useBenchmarkList].typeId,
        data: text,
        settings: {
          extra: { benchmark: benchmarkList[useBenchmarkList].id },
          optimization,
          optimizationValues,
          textLanguage
        }
      })
    if (resTaskRun?.data?.id) {
      return [resTaskRun.data.id, {}]

    } else {
      console.log('handleOurAi', 'start')
      return [0, { text: 'ai_start_error', header: 'ai_header_start_error' }]
    }
  } catch (e) {
    console.log('handleOurAi', e)
    return [0, { text: 'ai_start_error', header: 'ai_header_start_error' }]
  }
}
